export default __webpack_public_path__ + "static/media/DrawerHideLight.2ed66567.svg";